import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-static',
  templateUrl: './request-static.component.html',
  styleUrls: ['./request-static.component.css']
})
export class RequestStaticComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
